export class AnalyticsApi {
  constructor(client) {
    this.client = client
  }

  // Installations

  getInstallationChart(params) {
    return this.client.get(`/api/downloads/genericChart`, { params }).then((response) => response.data)
  }

  getInstallationsByCompanyChart(params) {
    return this.client.get(`/api/downloads/companyChart`, { params }).then((response) => response.data)
  }

  getInstallationByDeviceChart(params) {
    return this.client.get(`/api/downloads/deviceChart`, { params }).then((response) => response.data)
  }

  // Uso del Servicio

  getServiceUsageChart(params) {
    return this.client.get(`/api/usage/activeCustomerChart`, { params }).then((response) => response.data)
  }

  // Consultas

  getConsultasChart(params) {
    return this.client.get(`/api/activities/charts`, { params }).then((response) => response.data)
  }

  // Customer

  getActiveCustomersChart(params) {
    return this.client.get(`/api/customers/customerChart`, { params }).then((response) => response.data)
  }

  getUninstallCustomersChart(params) {
    return this.client.get(`/api/customers/uninstallationChart`, { params }).then((response) => response.data)
  }

  // Response

  getResponseTimeChart(params) {
    return this.client.get(`/api/responseTime/lineChart`, { params }).then((response) => response.data)
  }

  getFirstResponseTimeChart(params) {
    return this.client.get(`/api/responseTime/firstResponseLineChart`, { params }).then((response) => response.data)
  }

  getHistogramResponseChart(params) {
    return this.client.get(`/api/responseTime/histogramChart`, { params }).then((response) => response.data)
  }

  getHistogramFirstResponseChart(params) {
    return this.client
      .get(`/api/responseTime/firstResponseHistogramChart`, { params })
      .then((response) => response.data)
  }

  getDoughnutResponseChart(params) {
    return this.client.get(`/api/responseTime/doughnutCharts`, { params }).then((response) => response.data)
  }

  getDoughnutFirstResponseChart(params) {
    return this.client
      .get(`/api/responseTime/firstResponseDoughnutCharts`, { params })
      .then((response) => response.data)
  }

  //Qos

  getEvolutionScoreChart(params) {
    return this.client.get(`/api/qos/npsEvolution?startDate`, { params }).then((response) => response.data)
  }

  getCustomerSatisfactionEvolutionChart(params) {
    return this.client.get(`/api/qos/customerSatisfactionEvolution`, { params }).then((response) => response.data)
  }

  getEvolutionAvgReviewChart(params) {
    return this.client.get(`/api/qos/avgReviewEvolution`, { params }).then((response) => response.data)
  }

  getDoughnutNpsChart(params) {
    return this.client.get(`/api/qos/nps`, { params }).then((response) => response.data)
  }

  getDoughnutSatisfactionChart(params) {
    return this.client.get(`/api/qos/customerSatisfaction`, { params }).then((response) => response.data)
  }

  //Qos2
  getNpsComments(params) {
    return this.client.get(`/admin/v1/analytics/nps/comments`, { params }).then((response) => response.data)
  }

  getNpsRequestAnswer(params) {
    return this.client.get(`/admin/v1/analytics/nps/send-vs-receipt`, { params }).then((response) => response.data)
  }

  getEvolutionNps(params) {
    return this.client.get('/admin/v1/analytics/nps/evolution', { params }).then((response) => response.data)
  }

  getNpsCustomers(params) {
    return this.client.get('/admin/v1/analytics/nps/total', { params }).then((response) => response.data)
  }
}
